import { DESKTOP_WIDTH } from '~/config'

export const isDesktop = () => window.innerWidth >= DESKTOP_WIDTH

export const isMobile = () => !isDesktop()
